import { createContext, useContext } from 'react';
import { Drawers } from 'stores/Drawers';
import { NotificationsStore } from 'stores/Stores';
import { ErrorsStore } from 'stores/ErrorsStore';
import { NetworkStatus } from 'stores/NetworkStatus';
import { CalendarAPI } from 'stores/CalendarAPI';

export const storesContext = createContext({
	notifications: new NotificationsStore(),
	errorStore: new ErrorsStore(),
	drawers: new Drawers(),
	networkStatus: new NetworkStatus(),
	calendarApi: new CalendarAPI(),
});

export const useStore = () => useContext(storesContext);
